jQuery(document).ready(function($) {
	/* 
	Fixes Deep Links issue created by Divi
    */
    var links = $('a[href^="#"]:not([href="#"])');
    
    // Run only if there are deep links on the current page
   if( links.length ){
    	links.each(function(index, element) {
	    	// Add et_smooth_scroll_disabled to each link
		    $(element).addClass('et_smooth_scroll_disabled');
        });
    }

 });